import Seo from "@/components/common/Seo";
import { CONTACT } from "@/components/common/ContactBlock";

const CONTENT = {
  privacy: {
    title: "Privacy",
    body: [
      ["Privacy by default", "Your public identity is always anonymous. We never publicly display your full name, phone number, email, private documents or verification information."],
      ["Public vs private", "We separate public story data from private identity and verification data. Private contributor information is stored separately and is never exposed through public APIs."],
      ["Audio", "Your original voice recording is stored securely with controlled access. We never replace your voice with a synthetic voice."],
      ["Contact", `For any privacy request, contact ${CONTACT.email} or ${CONTACT.phone}.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    body: [
      ["Purpose", "Transplant Story presents transplant information and real patient experiences. It does not rank hospitals or doctors and does not provide medical advice."],
      ["Not medical advice", "Nothing on this platform is a clinical assessment, diagnosis, or recommendation. Always consult qualified medical professionals."],
      ["Contributions", "By sharing a journey you confirm it is your own genuine experience. Stories are moderated before publishing. We may decline or remove content."],
      ["No liability determination", "This platform is not a mechanism for determining medical negligence or resolving disputes."],
    ],
  },
  guidelines: {
    title: "Community Guidelines",
    body: [
      ["Be real", "Share your own genuine experience. Do not fabricate stories."],
      ["Be respectful", "Describe your experience without targeting individuals with defamatory or unverified allegations."],
      ["What we review", "Stories containing personal information, accusations, medical or financial claims, or sensitive family information are flagged for human review before publishing."],
      ["What this is not", "This is not an emergency service, a medical complaint mechanism, a diagnosis tool, or a means to determine negligence. We do not operate a public blacklist or name-and-shame system."],
      ["High-risk content", "High-risk allegations are not published automatically. They are reviewed carefully and may be declined."],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind] || CONTENT.privacy;
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <Seo title={`${c.title} — Transplant Story`} />
      <h1 className="text-4xl sm:text-5xl font-light tracking-tight text-ink">{c.title}</h1>
      <div className="mt-10 space-y-10">
        {c.body.map(([h, p]) => (
          <section key={h}>
            <h2 className="text-lg font-medium text-ink">{h}</h2>
            <p className="text-neutral-600 leading-relaxed mt-2">{p}</p>
          </section>
        ))}
      </div>
    </div>
  );
}
